import styled from 'styled-components';

export const DrawerStylesContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.medium.color};

  .chakra-modal__content {
    border-radius: 0px !important;
  }
`;
